"use client";

import React, { useState, useEffect } from "react";
import { Link } from "@/components/common/Link";
import { Card } from "@/components/ui/card";
import { Wind, Gauge, Zap, Activity, ShieldCheck } from "lucide-react";
import { cn } from "@/lib/utils";
const services = [{
  title: "Airport Transfers",
  description: "Reliable, punctual pickups and drop-offs at all major terminals with real-time flight tracking and meet-and-greet service.",
  icon: Wind
}, {
  title: "Wedding Services",
  description: "Elegant transportation for your special day, featuring pristine luxury vehicles and professional, tuxedoed chauffeurs.",
  icon: Gauge
}, {
  title: "Corporate Travel",
  description: "Seamless executive transport for meetings and events, providing a quiet, mobile office environment for busy professionals.",
  icon: Zap
}, {
  title: "Special Events",
  description: "Make a grand entrance at galas, concerts, or sporting events with our premium fleet and dedicated white-glove service.",
  icon: Activity
}, {
  title: "Hourly Charters",
  description: "Flexible, personalized chauffeur service for as long as you need, giving you total control over your itinerary and schedule.",
  icon: ShieldCheck
}];
export default function OurServices() {
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section data-section-id="3337" id="our-services" className="bg-background py-24 relative overflow-hidden">
      {}
      <style dangerouslySetInnerHTML={{
      __html: `
          @keyframes float-y {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-15px); }
          }
          .animate-float-y {
            animation: float-y 6s ease-in-out infinite;
          }
        `
    }} />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          
          {}
          <div className="lg:col-span-7 flex flex-col gap-6">
            <div className="mb-8">
              <h2 className="text-3xl md:text-5xl font-bold text-foreground font-display mb-4">
                Our Premium Services
              </h2>
              <p className="text-muted-foreground text-lg max-w-2xl font-sans">
                Experience the pinnacle of luxury transportation with our tailored chauffeur services, designed for those who value punctuality, safety, and sophistication.
              </p>
            </div>

            {services.map((service, i) => <div key={i} data-index={i}>
                <Link to="/ServicesPage" className="block group h-full">
                  <Card className={cn("h-full transition-all duration-300 ease-out", "bg-white", "border border-border border-l-transparent", "rounded-xl overflow-hidden", "hover:scale-[1.02] hover:shadow-medium hover:border-l-4 hover:border-l-primary")}>
                    <div className="flex flex-col sm:flex-row items-start p-6 sm:p-8 gap-6">
                      {}
                      <div className="shrink-0">
                        <div className="relative flex items-center justify-center size-14 rounded-xl bg-white border border-border shadow-sm group-hover:border-primary/30 transition-colors duration-300">
                          <service.icon className={cn("size-8 transition-colors duration-300", "text-primary", "fill-primary/5", "group-hover:text-primary-hover", "group-hover:fill-primary/10")} strokeWidth={1.5} />
                        </div>
                      </div>

                      {}
                      <div className="space-y-2">
                        <h3 className="text-[1.5rem] font-bold text-foreground font-display leading-tight group-hover:text-primary transition-colors duration-300">
                          {service.title}
                        </h3>
                        <p className="text-muted-foreground font-sans leading-relaxed">
                          {service.description}
                        </p>
                      </div>
                    </div>
                  </Card>
                </Link>
              </div>)}
          </div>

          {}
          <div className="lg:col-span-5 lg:sticky lg:top-24 hidden lg:block pt-12">
            <div className="relative rounded-lg bg-accent/30 border border-border animate-float-y transition-shadow duration-100 ease-linear" style={{
            boxShadow: `0px ${20 + scrollY * 0.03}px ${40 + scrollY * 0.06}px -10px rgba(10, 20, 50, ${Math.min(0.3, 0.1 + scrollY * 0.0005)})`
          }}>
              <div className="relative overflow-hidden rounded-lg aspect-[4/5]">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/chauffeur_luxury_suv.png" alt="Professional chauffeur opening luxury SUV door" className="w-full h-full object-cover" />
                
                {}
                <div className="absolute inset-0 bg-black/10 pointer-events-none" />
                <div className="absolute inset-0 ring-1 ring-inset ring-white/10 rounded-lg pointer-events-none" />
              </div>
            </div>

            {}
            <div className="absolute -z-10 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[140%] h-[100%] bg-primary/5 blur-3xl rounded-full pointer-events-none" />
          </div>

        </div>
      </div>
    </section>;
}